      // Function to open the cart drawer
      function openCartDrawer(cartDrawer) {
        cartDrawer.classList.add('active'); // Add a class to display the drawer
      }
  
      // Check if the current page URL is the cart page
      if (window.location.href.indexOf('/cart') > -1) {
        localStorage.setItem("cart-redirect", 1);
        window.location.href = '/';
      }

      document.addEventListener("DOMContentLoaded", function() {
        if(localStorage.getItem("cart-redirect")=='1'){
            var cartDrawer = document.querySelector('body > cart-drawer');
            openCartDrawer(cartDrawer);
            localStorage.setItem("cart-redirect", 0);
        }
    });